import config from './config';

export const loadGsiClient = (config) => new Promise((resolve, reject) => {
	const script = document.createElement('script');
	script.addEventListener('load', () => {
		resolve(window.google);
	});
	script.addEventListener('error', () => {
		reject(new Error('Failed to load the Google JavaScript Library.'));
	});
	script.src = config.gsiClientUrl;
	script.async = true;
	script.defer = true;
	document.head.appendChild(script);
});

export const initCodeClient = (
	google,
	options,
	params = { uxMode: 'popup' }
) => new Promise((resolve, reject) => {
	if (google) {
		google.accounts.oauth2
			.initCodeClient({
				client_id: (options && options.clientId) || '',
				scope: config.scopes,
				ux_mode: params.uxMode,
				callback: (response) => {
					if (response.code) {
						resolve(response);
					} else {
						reject(response);
					}
				},
				error_callback: (response) => {
					reject(response);
				}
			})
			.requestCode();
	} else {
		reject(new Error('Failed to load the Google JavaScript Library.'));
	}
});
